import React from 'react';
import '../App.css';
import { Headerapp } from './/headerapp'
import { Bodyappactivatebody} from './/bodyappactivatebody'
import { Footerapp } from './/footerapp'

export class Bodyappactivate extends React.Component {
  constructor(props){
    super (props);

    this.state={
        mail:''
    };
  }

  render(){
    return (
      <div className="App">        
        <Headerapp/>
        <Bodyappactivatebody mailRegister={this.props.mailRegister}/>
        <Footerapp/>
      </div>
    );
  }
}